import danZNemovitostiImg from "@/assets/dan-z-nemovitosti.jpg";

const bankovniUctyKrajePdf = new URL("../assets/documents/bankovni_ucty_Priloha_1.pdf", import.meta.url).href;
const bankovniUctyPredcisliPdf = new URL("../assets/documents/bankovni_ucty_Priloha_2.pdf", import.meta.url).href;
const jakSpravneZaplatitDanPdf = new URL("../assets/documents/jak-spravne-zaplatit-dan-v-roce-2023.pdf", import.meta.url).href;

export type ArticleBlock =
  | { type: "p"; html: string }
  | { type: "h2"; text: string }
  | { type: "h3"; text: string }
  | { type: "ol"; items: string[] }
  | { type: "ul"; items: string[] }
  | { type: "quote"; html: string }
  | { type: "image"; src: string; alt: string };

export interface Article {
  slug: string;
  title: string;
  perex: string;
  date: string; // ISO
  dateLabel: string;
  category: string;
  blocks: ArticleBlock[];
}

export const articles: Article[] = [
  {
    slug: "splatnost-dane-z-nemovitosti",
    title: "Splatnost daně z nemovitostí. Do kdy ji zaplatit a jak?",
    perex:
      "Vlastníci rezidenčních nemovitostí jsou povinni každý rok do konce května a listopadu zaplatit daň z nemovitostí. Jak si placení daně můžete usnadnit?",
    date: "2026-05-18",
    dateLabel: "18. 5. 2026",
    category: "Právo, daně a nemovitosti",
    blocks: [
      { type: "image", src: danZNemovitostiImg, alt: "Daň z nemovitostí – mince a dřevěný model domu" },
      { type: "h2", text: "Splatnost daně z nemovitých věcí" },
      {
        type: "p",
        html: 'Splatnost <a href="https://www.remaxalfa.cz/dan-z-nemovitych-veci/" target="_blank" rel="noopener noreferrer">daně z nemovitostí</a> se řídí ustanovením <a href="https://www.zakonyprolidi.cz/cs/1992-338?text=15" target="_blank" rel="noopener noreferrer">§ 15 zákona č. 338/1992 Sb., o dani z nemovitých věcí</a>, ve znění pozdějších předpisů.',
      },
      { type: "p", html: "Daň z nemovitých věcí je splatná:" },
      {
        type: "ol",
        items: [
          "u <strong>poplatníků daně provozujících zemědělskou výrobu a chov ryb</strong> ve dvou stejných splátkách, a to nejpozději <strong>do 31. srpna a do 30. listopadu</strong> zdaňovacího období,",
          "u <strong>ostatních poplatníků</strong> daně ve dvou stejných splátkách, a to <strong>nejpozději do 31. května a do 30. listopadu</strong> zdaňovacího období.",
        ],
      },
      {
        type: "p",
        html: "Nepřesáhne-li roční daň z nemovitých věcí částku 5 000 Kč, je splatná najednou, a to nejpozději do 31. května zdaňovacího období. Ke stejnému datu lze daň z nemovitých věcí zaplatit najednou i při vyšší částce.",
      },
      {
        type: "p",
        html: "Pokud nechcete každý rok myslet na placení daně z nemovitostí, můžete si platby zautomatizovat.",
      },
      { type: "h3", text: "1. Platba přes SIPO" },
      {
        type: "p",
        html: 'Daň z nemovitostí můžete platit prostřednictvím SIPO (soustředěné inkasní platby obyvatelstva). V takovém případě je třeba svému finančnímu úřadu odevzdat oznámení o placení daně z nemovitostí prostřednictvím SIPO spolu se spojovacím číslem SIPO. Více informací najdete na webu <a href="https://financnisprava.gov.cz/cs/dane/dane/dan-z-nemovitych-veci/sipo" target="_blank" rel="noopener noreferrer">Finanční správy</a>.',
      },
      { type: "h3", text: "2. Trvalý příkaz" },
      {
        type: "p",
        html: "Druhou pohodlnou variantou je sjednat si u banky trvalý příkaz se splatností každoročně ke konci května – a máte po starostech.",
      },
      {
        type: "p",
        html: "Samozřejmě můžete každý rok vytvářet individuální platební příkazy nebo platbu provést na poště přes poštovní poukázku typu A. Tento způsob je ale zbytečně drahý a navíc ztrácíte čas, proto ho nedoporučuji.",
      },
      { type: "h2", text: "Bankovní účty finančních úřadů" },
      {
        type: "p",
        html: 'Čísla účtů najdete na stránkách <a href="https://financnisprava.gov.cz/cs/dane/placeni-dani/bankovni-ucty-financnich-uradu" target="_blank" rel="noopener noreferrer">Finanční správy</a>.',
      },
      {
        type: "p",
        html: `Předčíslí bankovních účtů pro daň z nemovitostí je <strong>7755</strong>. <a href="${bankovniUctyPredcisliPdf}" target="_blank" rel="noopener noreferrer">Tabulku všech předčíslí si můžete stáhnout na portálu Finanční správy</a>.`,
      },
      {
        type: "p",
        html: `Čísla matrik bankovních účtů se liší podle krajů. <a href="${bankovniUctyKrajePdf}" target="_blank" rel="noopener noreferrer">Kompletní seznam pro jednotlivé kraje si můžete stáhnout na portálu Finanční správy</a>.`,
      },
      {
        type: "p",
        html: 'Kód banky je <strong>0710</strong> (ČNB). Jako variabilní symbol použijte své rodné číslo.',
      },
      {
        type: "p",
        html: `Podrobné informace o tom, <a href="${jakSpravneZaplatitDanPdf}" target="_blank" rel="noopener noreferrer">jak správně zaplatit daň z nemovitostí</a>, najdete na portálu <a href="https://financnisprava.gov.cz/cs/dane/placeni-dani" target="_blank" rel="noopener noreferrer">Finanční správy</a>.`,
      },
      {
        type: "p",
        html: '<em>Autor článku: Petr Podlešák, manažer RE/MAX Alfa</em>',
      },
    ],
  },
];

export const getArticleBySlug = (slug: string) => articles.find((a) => a.slug === slug);
